export default __webpack_public_path__ + "assets/images/enhancedWebswitcherIMG4.svg";